module.exports = __webpack_public_path__ + "images/花筑村全景_04-2.jpg?v=a1230c40";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_04-2.jpg
 ** module id = 90
 ** module chunks = 1 2
 **/